<template>
  <div class="sb-masonry-item">
    <!--
      @slot text, components, or HtmlElements as children of the component
    -->
    <slot />
  </div>
</template>
<script>
import { SbMasonryItemConfig } from '@src/components/Masonry/utils/sbMasonryItemConfig';

export default {
  name: 'SbMasonryItem',
  inject: ['sbMasonry'],
  props: {
    configurations: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.sbMasonry.items.push(new SbMasonryItemConfig(this.configurations, this.$el));
  },
};
</script>
<style lang="scss">
@import '@src/components/Masonry/style/sb-masonry-item.scss';
</style>
